import { render, staticRenderFns } from "./CsListboxItem.vue?vue&type=template&id=5a8c427a&"
import script from "./CsListboxItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsListboxItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports